import axios from 'axios';

import { PANEL_API_ENDPOINTS } from 'config';
import { getPanelBackendUrl, getPanelOrganizationId } from 'helpers';

const createCheckoutSession = (payment_id) => {
  const url = `${getPanelBackendUrl()}${PANEL_API_ENDPOINTS.STRIPE_CHECKOUT_SESSION}`;
  const requestOptions = {
    crossDomain: true,
    withCredentials: true,
    method: 'POST',
    url,
    headers: {
      'X-CSRFToken': localStorage.getItem('panel_csrf_token')
    },
    data: {
      payment_id: payment_id
    }
  };
  return axios(requestOptions);
};

const createOneTimePaymentCheckoutSession = (payload) => {
  const url = `${getPanelBackendUrl()}${PANEL_API_ENDPOINTS.STRIPE_ONETIME_PAYMENT_CHECKOUT_SESSION}`;
  const requestOptions = {
    crossDomain: true,
    withCredentials: true,
    method: 'POST',
    url,
    headers: {
      'X-CSRFToken': localStorage.getItem('panel_csrf_token')
    },
    data: payload
  };
  return axios(requestOptions);
};

const fetchPaymentMethod = () => {
  const url = `${getPanelBackendUrl()}${PANEL_API_ENDPOINTS.PAYMENT_METHOD_API}`;
  const requestOptions = {
    crossDomain: true,
    withCredentials: true,
    method: 'GET',
    url
  };
  return axios(requestOptions);
};

const updateOrgTermsConditions = (accept_terms_conditions, inputs) => {
  const url = `${getPanelBackendUrl()}${PANEL_API_ENDPOINTS.ORGANIZATIONS_API}${getPanelOrganizationId()}/`;
  const requestOptions = {
    crossDomain: true,
    withCredentials: true,
    method: 'PATCH',
    url,
    headers: {
      'X-CSRFToken': localStorage.getItem('panel_csrf_token')
    },
    data: {
      accept_terms_conditions: accept_terms_conditions,
      ...inputs
    }
  };
  return axios(requestOptions);
};

function checkSubDomainAvailability(payload) {
  const url = `${getPanelBackendUrl()}${PANEL_API_ENDPOINTS.VALIDATE_CREATE_SITE}`;
  payload['csrfmiddlewaretoken'] = localStorage.getItem('panel_csrf_token');
  const requestOptions = {
    crossDomain: true,
    withCredentials: true,
    method: 'POST',
    url,
    headers: {
      'X-CSRFToken': localStorage.getItem('panel_csrf_token')
    },
    data: payload
  };
  return axios(requestOptions);
}

function fetchBillingHistory(payload) {
  let url = `${getPanelBackendUrl()}${PANEL_API_ENDPOINTS.FETCH_BILLING_HISTORY}`;
  if (Object.keys(payload).length) {
    url +=
      '?' +
      Object.keys(payload)
        .map((key) => key + '=' + payload[key])
        .join('&');
  }
  const requestOptions = {
    crossDomain: true,
    withCredentials: true,
    method: 'GET',
    url
  };
  return axios(requestOptions);
}

function exportBillingHistory() {
  let url = `${getPanelBackendUrl()}${PANEL_API_ENDPOINTS.EXPORT_BILLING_HISTORY}`;
  const requestOptions = {
    crossDomain: true,
    withCredentials: true,
    method: 'GET',
    url
  };
  return axios(requestOptions);
}

function billingPortalSession() {
  let url = `${getPanelBackendUrl()}${PANEL_API_ENDPOINTS.CUSTOMER_PORTAL_SESSION}`;
  const requestOptions = {
    crossDomain: true,
    withCredentials: true,
    method: 'POST',
    url,
    headers: {
      'X-CSRFToken': localStorage.getItem('panel_csrf_token')
    }
  };
  return axios(requestOptions);
}

export const pricingService = {
  fetchPaymentMethod,
  createCheckoutSession,
  updateOrgTermsConditions,
  createOneTimePaymentCheckoutSession,
  checkSubDomainAvailability,
  fetchBillingHistory,
  exportBillingHistory,
  billingPortalSession
};
